import React from "react";
import { paths } from "./path";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import useMsTeamsContext from "../msTeams/hooks";
import OutsideMsTeams from "../msTeams/outsideMsTeams/OutsideMsTeams";
import CustomerMeetings from "../customerMeetings/CustomerMeetings";
import InMeetingApp from "../inMeetingApp/InMeetingApp";
import OrganizerNoRecordingWarning from "../inMeetingApp/prompts/OrganizerNoRecordingWarning";
import OrganizerMeetingTypePrompt from "../inMeetingApp/prompts/OrganizerMeetingTypePrompt";
import CustomerJoinsTheLobbyPrompt from "../inMeetingApp/prompts/CustomerJoinsTheLobbyPrompt";
import ScreenSharingWarningPrompt from "../inMeetingApp/prompts/ScreenSharingWarningPrompt";
import TranslationProvider from "../shared/translation/TranslationProvider";
import InsideOriginTenant from "../msTeams/insideOriginTenant/InsideOriginTenant";

export const Routes: React.FC<{}> = () => {
    const msTeamsContext = useMsTeamsContext();

    if (msTeamsContext.isInitializing) {
        return null;
    }

    if (!msTeamsContext.isAppInsideMsTeams || !msTeamsContext.tenantId) {
        return <OutsideMsTeams />;
    }

    return (
        <InsideOriginTenant tenantId={msTeamsContext.tenantId}>
            <TranslationProvider>
                <RouterRoutes>
                    <Route path={paths.customerMeetings} element={<CustomerMeetings />} />
                    <Route path={paths.inMeetingApp} element={<InMeetingApp />} />
                    <Route path={paths.organizerNoRecordingWarning} element={<OrganizerNoRecordingWarning />} />
                    <Route path={paths.organizerMeetingTypePrompt} element={<OrganizerMeetingTypePrompt />} />
                    <Route path={paths.customerJoinsLobbyPrompt} element={<CustomerJoinsTheLobbyPrompt />} />
                    <Route path={paths.screenSharingWarningPrompt} element={<ScreenSharingWarningPrompt />} />
                </RouterRoutes>
            </TranslationProvider>
        </InsideOriginTenant>
    );
};

export default Routes;
